import React from "react";
import ArchiveConfig from "archive/components/ArchiveConfig";
import ArchiveCreationForm from "archive/components/ArchiveCreationForm";
import ArchiveActions from "archive/ArchiveActions";
import { Spinner, IfPermitted } from "components/common";
import { Row, Col } from "components/bootstrap";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { ARCHIVE_LICENSE_WARNING_TEXT, ARCHIVE_LICENSE_WARNING_TITLE } from "archive/constants";
const _createArchive = (indexName) => {
  ArchiveActions.createArchive(indexName);
};
const ArchiveCreationSection = ({ indices = void 0 }) => /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["archive:create", "archiveconfig:read"], anyPermissions: true }, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "archive:create" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(
  LicenseCheck,
  {
    text: ARCHIVE_LICENSE_WARNING_TEXT,
    title: ARCHIVE_LICENSE_WARNING_TITLE,
    bsStyle: "danger",
    licenseSubject: LICENSE_SUBJECTS.archive,
    hideChildren: true
  },
  !(indices == null ? void 0 : indices.length) ? /* @__PURE__ */ React.createElement(Spinner, { text: "Loading indices" }) : /* @__PURE__ */ React.createElement(ArchiveCreationForm, { indices, createArchive: _createArchive })
))), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "archiveconfig:read" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(ArchiveConfig, null)))));
export default ArchiveCreationSection;
